import { IllegalArgumentError } from 'faro-common-model';
import { isEmpty, capitalize } from 'lodash-es';
export var UserCommentStatus;
(function (UserCommentStatus) {
    UserCommentStatus["Open"] = "Open";
    UserCommentStatus["Closed"] = "Closed";
})(UserCommentStatus || (UserCommentStatus = {}));
export function toUserCommentStatus(userCommentStatus) {
    if (isEmpty(userCommentStatus)) {
        return UserCommentStatus.Open;
    }
    const capitalizedStatus = capitalize(userCommentStatus);
    if (Object.values(UserCommentStatus).includes(capitalizedStatus)) {
        return capitalizedStatus;
    }
    throw new IllegalArgumentError(`Invalid user comment status [${userCommentStatus}]`);
}
//# sourceMappingURL=Enums.js.map